import { render, staticRenderFns } from "./WeeklyExerciseList.vue?vue&type=template&id=e89e5896&scoped=true"
import script from "./WeeklyExerciseList.vue?vue&type=script&lang=js"
export * from "./WeeklyExerciseList.vue?vue&type=script&lang=js"
import style0 from "./WeeklyExerciseList.vue?vue&type=style&index=0&id=e89e5896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89e5896",
  null
  
)

export default component.exports